import { all, fork } from 'redux-saga/effects';
import { modalSaga } from './modal';

export const offerDetailsSaga = function*() {
  yield all([fork(modalSaga)]);
};
